import { render, staticRenderFns } from "./TableMiscellaneous.vue?vue&type=template&id=524f9cba"
import script from "./TableMiscellaneous.vue?vue&type=script&lang=js"
export * from "./TableMiscellaneous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports